import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.couponBaseUrl);

export default {
  // 优惠券
  getCouponInfo: params => request.get(`/api/share-mall-gateway-coupon/1.0/query_coupon_info`, { params }), // 查询优惠券
  getCouponHistory: params => request.get(`/api/share-mall-gateway-coupon/1.0/query_history_coupon`, { params }), // 查询优惠券历史
  getMyCoupon: params => request.get(`/api/share-mall-gateway-coupon/1.0/query_my_coupon_info`, { params }), // 优惠券
  getCouponDetail: params => request.get(`/api/share-mall-gateway-coupon/1.0/query_coupon_detail`, { params }) // 查询优惠券详情
};
